import * as React from 'react';
import * as _ from 'lodash';
import { IGlobalSort } from '../../models/sorts';
import { AnalyticsCategories, EventName, TriggerAnalyticsEventFor } from '../../models/analytics';

export interface ISortProps<T> {
    sort: IGlobalSort<T>;
    sortGroupName: string;
    activeSortDirection?: number;
}

export interface ISortGroupProps<T> {
    sortGroupName: string;
    sorts: IGlobalSort<T>[];
    onSort?: (sort: IGlobalSort<T>) => void;
    customClasses?: string;
    sortLabel?: string;
}

export function SortGroup<T>({ sorts, onSort = (_sort: IGlobalSort<T>) => { }, customClasses = '', sortGroupName, sortLabel }: ISortGroupProps<T>) {
    const OnChange = (newId: string) => {
        let sort = _.find(sorts, (s) => s.sortId === newId);
        TriggerAnalyticsEventFor(EventName.SortClickedEvent, AnalyticsCategories.Search, newId, sort.display);
        onSort(sort);
    };

    return (
        <div className={'adage-search-select global-sort ' + customClasses}>
            {sorts && (
                <React.Fragment>
                    <label htmlFor="global-sort" className="visually-hidden">{sortLabel}</label>
                    <select
                        id="global-sort"
                        value={sorts.filter((x) => x.selected)[0].sortId}
                        onChange={(e) => OnChange(e.target.value)}
                    >
                        {sorts.map((s: IGlobalSort<T>) => (
                            <Sort key={s.sortId} sort={s} sortGroupName={sortGroupName} />
                        ))}
                    </select>
                </React.Fragment>
            )}
        </div>
    );
};

export function Sort<T>({ sort }: ISortProps<T>) {
    return (
        <option value={sort.sortId}>{sort.display}</option>
    );
}
